import instance from './AxiosServices';

const ContestService = {
  getAllContests: async () => {
    return instance.get('/contests/partner/all');
  },

  createContest: async (contestData) => {
    return instance.post('/contests/partner/create', contestData);
  },

  updateContest: async (id, contestData) => {
    return instance.put(`/contests/partner/${id}`, contestData);
  },

  getContestById: async (id) => {
    return instance.get(`/contests/${id}`);
  },

  deleteContest: async (id) => {
    return instance.delete(`/contests/partner/${id}`);
  }
};

export default ContestService;
